import React, { SVGProps } from 'react';

interface IconProps extends SVGProps<SVGSVGElement> {
  color: string;
}

const Warning = ({ color = '#fff', ...props }: IconProps) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    <path
      d="M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16.001A8 8 0 0 0 10 18Zm-1-5h2v2H9v-2Zm0-8h2v6H9V5Z"
      fill={color}
    />
  </svg>
);

export default Warning;
